import {inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {AttachProductCardImage, ProductCardImage} from "../types/product-card-image.types";
import {baseUrl} from "../../../../core/constants/base-url";

@Injectable({
  providedIn: 'root'
})
export class ProductCardImagesApiService {
  private http: HttpClient = inject(HttpClient);

  private url: string = `${baseUrl}/product-card-files`;

  public getProductCardImages(productCardId: number): Observable<Array<ProductCardImage>> {
    return this.http.get<Array<ProductCardImage>>(`${this.url}`, { params: { productCardId: productCardId } });
  }

  public attachProductCardImage(attachProductCardImage: AttachProductCardImage): Observable<ProductCardImage> {
    return this.http.post<ProductCardImage>(`${this.url}`, attachProductCardImage);
  }

  public deleteProductCardImage(id: number): Observable<void> {
    return this.http.delete<void>(`${this.url}/${id}`);
  }
}
